/* ============================================================================
   mm-text-image-video.js — vidéos YouTube des sections texte/image/vidéo
   ----------------------------------------------------------------------------
   Chargé GLOBALEMENT (defer) par layout/theme.liquid — l'ancien chargement
   local dans sections/MM-Text-Image-Video.liquid est commenté. Cible les
   slides .splide__slide-youtube de cette section :
   - sur mobile (<768px), si la slide a un data-mobile (ID YouTube alternatif),
     remplace la source de l'iframe par la version mobile (muette) ;
   - au clic sur l'image d'aperçu (.mm-video-preview), ajoute autoplay=1 à
     l'URL de l'iframe (ce qui la recharge en lecture) et masque l'aperçu.
   NB : le test `if (slideYoutubeAll)` est toujours vrai (une NodeList vide
   reste truthy) — c'est le forEach vide qui rend le script inoffensif
   ailleurs ; 3 console.log de debug restent exécutés en production.
   ========================================================================== */

const slideYoutubeAll = document.querySelectorAll(".splide__slide-youtube");
if (slideYoutubeAll) {
  slideYoutubeAll.forEach(slideYt => {
    console.log('slideYt', slideYt)
    const previewImage = slideYt.querySelector(".mm-video-preview");
    const iframe = slideYt.querySelector('iframe');
    if (window.innerWidth < 768) {
      const youtubeMobileID = slideYt.dataset.mobile;
      if (youtubeMobileID) {
        let srcMobile = `https://www.youtube.com/embed/${youtubeMobileID}?mute=1`;
        console.log('srcmobile', srcMobile)
        iframe.src = srcMobile;
        console.log("iframe.src", iframe.src);

      }
    }
    if (previewImage) {
      previewImage.addEventListener("click", () => {
        let videoSrc = iframe.src;
        // Vérifie si autoplay=1 est déjà présent
        if (!videoSrc.includes("autoplay=1")) {
          // Ajoute autoplay=1
          const separator = videoSrc.includes("?") ? "&" : "?";
          videoSrc += `${separator}autoplay=1`;
        }
        iframe.src = videoSrc;
        previewImage.style.display = "none"; // Cache l'image
		  });
	  }
  });
}
